import { EExtendsMergeStrategy } from "@devowl-wp/api-real-cookie-banner";
/**
 * By default no strategies are disabled, except when parameter `isArray` is set to `true`.
 */ function getDisableStrategies(isArray = false, forceDisable = []) {
    const defaultDisabledStrategies = isArray ? [] : [
        EExtendsMergeStrategy.Append
    ];
    const additionalDisabledStrategies = forceDisable || [];
    return [
        ...new Set([
            ...defaultDisabledStrategies,
            ...additionalDisabledStrategies
        ])
    ];
}
function clearFieldsByMergeStrategies(template) {
    if ((template?.extendedTemplateId || template?.extends || template.extendsIdentifier) && template?.extendedMergeStrategies) {
        for (const key of Object.keys(template.extendedMergeStrategies)){
            if ([
                EExtendsMergeStrategy.Clear,
                EExtendsMergeStrategy.Keep
            ].includes(template.extendedMergeStrategies[key])) {
                delete template[key];
            }
        }
    }
}
export { clearFieldsByMergeStrategies, getDisableStrategies };
